<template>
  <div class="d-flex flex-row mx-2" @click="$emit('click')">
    <div class="checkbox p-1" :class="{
      selected: filter_item.selected,
      subSelected: filter_item.fl_isParentCategory && !filter_item.selected
    }"></div>
    <div class="filtername p-1">
      {{ filter_item.value }} <span class="frequency" v-if="filter_item.frequency > 0">({{ filter_item.frequency }})</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "value_select",
  props: ['filter_item'],
}
</script>

<style scoped>

.checkbox {
  width: 20px;
  height: 20px;
  background-color: #f5f5f7;
  border-radius: 2px;
  border: 1px solid #efeff1;
  margin: 3px;
}

.checkbox.selected {
  background-color: #1768a5;
  border-color: #1768a5;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:%23fff;%7D%3C/style%3E%3C/defs%3E%3Cpath class='a' d='M7.45,15.67,3.39,11.61a.75.75,0,1,1,1.06-1.06l3,2.95,8.12-8.92a.75.75,0,1,1,1.11,1Z'/%3E%3C/svg%3E");
}

.checkbox.subSelected {
  border-color: #1768a5;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3E%3Cdefs%3E%3Cstyle%3E.a%7Bfill:%231768a5;%7D%3C/style%3E%3C/defs%3E%3Cpath class='a' d='M7.45,15.67,3.39,11.61a.75.75,0,1,1,1.06-1.06l3,2.95,8.12-8.92a.75.75,0,1,1,1.11,1Z'/%3E%3C/svg%3E");
}

.frequency {
  font-size: 0.8rem;
  white-space: nowrap;
}
</style>
